import eventbus from 'nanobus'
export default eventbus();